import Icon from './Icon';

const Unlocked = ({ className }) => (
  <Icon name="unlocked" className={className} viewBox="0 0 469.333 469.333">
    <g>
      <path
        d="M0,205.777v234.274h312.367V205.777H0z M167.582,323.913h0.06v46.852h-23.433v-46.852h0.576
      c-8.508-4.211-14.366-12.954-14.366-23.087c0-14.225,11.533-25.766,25.766-25.766s25.775,11.541,25.775,25.766
      C181.956,310.959,176.09,319.701,167.582,323.913z"
      />
      <path
        d="M469.333,205.777h-40.61v-58.569c0-20.655-8.034-40.068-22.643-54.673
      c-14.601-14.601-34.018-22.643-54.669-22.643c-20.651,0-40.068,8.043-54.669,22.643c-14.601,14.609-22.652,34.022-22.652,54.673
      v58.569h-40.61v-58.569c0-31.501,12.275-61.116,34.543-83.383c22.276-22.276,51.883-34.543,83.383-34.543
      c31.492,0,61.107,12.267,83.383,34.543c22.268,22.268,34.534,51.883,34.534,83.383v58.569H469.333z"
      />
    </g>
  </Icon>
);

export default Unlocked;
